import type { RgbLibApiClient, SatchelApiClient } from "@satchel/core";

interface ServerWallets {
  satchelApi: Pick<SatchelApiClient, "getAluvmPhrase" | "deleteWallet">;
  rgbLibApi: Pick<RgbLibApiClient, "restoreWallet" | "deleteWallet">;
  walletName: string;
  password: string;
  network: string;
}

/**
 * Delete the SATCHEL's wallets on both servers, keys included. The AluVM-RGB
 * wallet goes first: its id comes from the phrase that only the Rholang-RGB
 * server can derive, and restoring a wallet rgb-lib-server holds returns its id.
 */
export async function deleteServerWallets({
  satchelApi,
  rgbLibApi,
  walletName,
  password,
  network,
}: ServerWallets): Promise<void> {
  const { mnemonic } = await satchelApi.getAluvmPhrase(walletName, password, network);
  const { wallet_id } = await rgbLibApi.restoreWallet(network, mnemonic, password);
  await rgbLibApi.deleteWallet(wallet_id, password);
  await satchelApi.deleteWallet(walletName, password, network);
}
